const LOAD_DATA_MASTER_COUNTRY         = 'LOAD_DATA_MASTER_COUNTRY'
const LOAD_DATA_MASTER_COUNTRY_SUCCESS = 'LOAD_DATA_MASTER_COUNTRY_SUCCESS'
const LOAD_DATA_MASTER_COUNTRY_FAILED  = 'LOAD_DATA_MASTER_COUNTRY_FAILED'
const UNMOUNT_DATA_MASTER_COUNTRY      = 'UNMOUNT_DATA_MASTER_COUNTRY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_COUNTRY:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_COUNTRY_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_COUNTRY_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_COUNTRY:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default countryReducer